import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminTable.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

const AdminStudents = () => {

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMsg, setSelectedMsg] = useState(null);

  const recordsPerPage = 10;

  /*==== DATE FORMAT ====*/
  const formatDate = (date) => {

    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
  
    return `${day}-${month}-${year}`;
  };

  /* LOAD DATA */
  useEffect(() => {

    const loadData = async () => {
      try {
        const res = await axios.get("/api/students");
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
    };
  
    loadData();
  
  }, []);


  /* DELETE */
  const handleDelete = async (id) => {

    if (window.confirm("Delete This Registration?")) {

      try {

        await axios.delete(
          `/api/students/${id}`);

        const res = await axios.get(
          "/api/students");

        setData(res.data);

      } catch (err) {
        console.error(err);
      }

    }

  };

  /* FILTER */
  const filteredData = data.filter((item) => {

    const matchSearch =

      (item.yourName || "").toLowerCase().includes(search.toLowerCase()) ||
      (item.fatherName || "").toLowerCase().includes(search.toLowerCase()) ||
      (item.phoneNumber || "").toLowerCase().includes(search.toLowerCase()) ||
      (item.classApplyfor || "").toLowerCase().includes(search.toLowerCase());

    const matchDate = date
      ? new Date(item.submitDate).toLocaleDateString("en-CA") === date
      : true;

    return matchSearch && matchDate;

  });


  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // const today = new Date().toDateString();
  const today = new Date().toLocaleDateString("en-CA");

  const totalMessages = data.length;

  const todayMessages = data.filter(
    // (item) => new Date(item.submitDate).toDateString() === today
    (item) => new Date(item.submitDate).toLocaleDateString("en-CA") === today
  ).length;

  /* EXPORT EXCEL */
  const exportExcel = () => {

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Students");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const file = new Blob([buffer], { type: "application/octet-stream" });

    saveAs(file, "Online_Registration.xlsx");

  };

  /* CHART DATA */
  const chartData = data.reduce((acc, item) => {

    const d = new Date(item.submitDate).toLocaleDateString("en-IN");

    const found = acc.find((x) => x.date === d);

    if (found) {
      found.count += 1;
    } else {
      acc.push({ date: d, count: 1 });
    }

    return acc;

  }, []);


  return (

    <div>

      <h2 className="admin-title">
        Online Registrations
      </h2>

      {/* DASHBOARD */}
      <div className="dashboard">
        <div className="card">Total Registrations : {totalMessages}</div>
        <div className="card">Today Registrations : {todayMessages}</div>
      </div>

      {/* FILTER */}
      <div className="d-flex gap-3 flex-wrap mb-3">

        <input
          type="text"
          placeholder="Search..."
          className="search-box"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <input
          type="date"
          className="search-box"
          onChange={(e) => setDate(e.target.value)}
        />

        <button className="export-btn" onClick={exportExcel}>
          Export Excel
        </button>

      </div>

      {/* GRAPH */}
      <div style={{ overflowX: "auto", marginBottom: "20px" }}>

        <BarChart width={600} height={300} data={chartData}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" />
        </BarChart>

      </div>

      {/* TABLE */}
      <table className="admin-table">

        <thead>
          <tr>
            <th>ID</th>
            <th>Photo</th>
            <th>Name</th>
            <th>Father</th>
            <th>Phone</th>
            <th>Class</th>
            <th>Details</th>
            <th>Submission Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {currentRecords.length > 0 ? (

            currentRecords.map((item) => (

              <tr key={item.id}>

                <td>{item.id}</td>

                <td>
                  <img
                    className="admin-img"
                    src={`${BASE_URL}/uploads/students/${item.photo}`}
                    alt=""
                  />
                </td>

                <td>{item.yourName}</td>
                <td>{item.fatherName}</td>
                <td>{item.phoneNumber}</td>
                <td>{item.classApplyfor}</td>

                <td>
                  <button onClick={() => setSelectedMsg(item)}>
                    View
                  </button>
                </td>

                <td>
                  {/* {new Date(item.submitDate).toLocaleString()} */}
                  {formatDate(item.submitDate)}
                </td>

                <td>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </button>
                </td>

              </tr>

            ))

          ) : (

            <tr>
              <td colSpan="9" className="text-center">
                No Data Found
              </td>
            </tr>

          )}

        </tbody>

      </table>


      {/* PAGINATION */}
      <div className="pagination">

        {Array.from({ length: totalPages }, (_, i) => (

          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={currentPage === i + 1 ? "active" : ""}
          >
            {i + 1}
          </button>

        ))}

      </div>


      {/* MODAL */}
      {selectedMsg && (

        <div className="modal-overlay" onClick={() => setSelectedMsg(null)}>

          <div className="modal-box" onClick={(e) => e.stopPropagation()}>

            <h4>Student Details</h4>
            <hr/>

            <p><b>Name:</b> {selectedMsg.yourName}</p>
            {/* <p><b>Birth Date:</b> {selectedMsg.birthdate}</p> */}
            <p><b>Birth Date:</b> {formatDate(selectedMsg.birthdate)}</p>
            <p><b>Age:</b> {selectedMsg.age}</p>
            <p><b>Father Name:</b> {selectedMsg.fatherName}</p>
            <p><b>Address:</b> {selectedMsg.addressComplete}</p>
            <p><b>Phone:</b> {selectedMsg.phoneNumber}</p>
            <p><b>Email:</b> {selectedMsg.email}</p>
            <p><b>Gender:</b> {selectedMsg.gender}</p>
            <p><b>Class Apply For:</b> {selectedMsg.classApplyfor}</p>
            <hr/>
            <button onClick={() => setSelectedMsg(null)}>
              Close
            </button>

          </div>

        </div>

      )}

    </div>

  );

};

export default AdminStudents;